
import type { SdkMixin } from '@wix/lean-components-infra';
import type { ValidationSchema } from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import { createLeanComponentSDK } from '@wix/lean-components-infra/runtime/sdk';
import type { IWutRadioButtonProps } from '../../../components/WutRadioButton/WutRadioButton.props';

const sdkSchema = {
  "radioGroupName": {
    "type": "string",
    "persistence": "multiLangVar"
  },
  "value": {
    "type": "string",
    "persistence": "multiLangVar"
  },
  "checked": {
    "type": "boolean",
    "persistence": "multiLangVar"
  },
  "required": {
    "type": "boolean",
    "persistence": "multiLangVar"
  }
};

const validationSchema: ValidationSchema = {
  "type": [
    "object"
  ],
  "properties": {
    "radioGroupName": {
      "maxLength": 120,
      "type": [
        "string"
      ]
    },
    "value": {
      "maxLength": 120,
      "type": [
        "string"
      ]
    },
    "checked": {
      "type": [
        "boolean"
      ]
    },
    "required": {
      "type": [
        "boolean"
      ]
    }
  }
};

const mixins = ["changeable","focusable","disableable","accessible"] as Array<SdkMixin>;

export const sdk = createLeanComponentSDK<IWutRadioButtonProps>({
  sdkSchema,
  validationSchema,
  mixins
});

export default createComponentSDKModel(sdk);

